import { Box, Grid, Typography } from "@mui/material";
import Preloader from "../common/Preloader";
import BlogsCard from "./BlogsCard";

const BlogsGrid = ({ blogs = [], loadingBlogs = false }) => {
  if (loadingBlogs) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <Preloader />
      </Box>
    );
  }

  if (!Array.isArray(blogs) || blogs.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="h6">No blogs found</Typography>
        <Typography variant="body2" color="text.secondary">
          Check back later for new content
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      {blogs.map((blog) => (
        <Grid item xs={12} sm={6} md={4} key={blog._id}>
          <BlogsCard blog={blog} />
        </Grid>
      ))}
    </Grid>
  );
};

export default BlogsGrid;
